export const BREADCRUMBNAV_GET_REQUEST = 'BREADCRUMBNAV_GET_REQUEST';
export const BREADCRUMBNAV_GET_SUCCESS = 'BREADCRUMBNAV_GET_SUCCESS';
export const BREADCRUMBNAV_GET_ERROR = 'BREADCRUMBNAV_GET_ERROR';
export const BREADCRUMBNAV_CLEAR = 'BREADCRUMBNAV_CLEAR';
